<template>
    <div
        class="mobile-general-form-button"
        :class="`uuid-${config.uuid} ${shouldFixed && 'fix-bottom'} ${noFixed && 'no-show'}`"
        :style="fixStyle"
        v-show="!props.hide && hideBtn"
        ref="btn"
    >
        <sp-button
            :style="{opacity: buttonGray ? 0.5 : 1}"
            :type="props.type"
            :disabled="selfDisabled"
            :ghost="!!props.ghost"
            :size="props.size"
            @click="handleClick"
        >
            <img
                v-if="props.iconSrc"
                slot="icon"
                v-bind="iconAttrs"
            />
            {{ i18n(props.text) || i18nLabel }}
        </sp-button>
    </div>
</template>
<script>
import { Button, Toast } from '@ks/sharp-ui';
import { getValueByPath, isIOS } from '../../utils';
import ComponentBase from '../component-base';
import { component } from './props';
import { component as FormContainerComp } from '../mobile-general-form-container/props';
import { inCollect, inIm } from '../../utils/bridge/ui';

export default {
    name: component,
    components: {
        SpButton: Button,
    },
    extends: ComponentBase,
    data() {
        return {
            shouldFixed: false,
            halfRatio: 1,
            isInIm: inIm,
            fixStyle: {},
            noFixed: false,
            docmHeight: document.documentElement.clientHeight || document.body.clientHeight,
            showHeight: document.documentElement.clientHeight || document.body.clientHeight,
            clickTimer: 0,
            timer: null,
        };
    },
    computed: {
        iconAttrs() {
            return {
                src: this.props.iconSrc,
            };
        },
        hideBtn() {
            if (!['submit', 'submit-container'].includes(this.props.actionType)) {
                return true;
            }
            return !this.globalModel.hideSubmitStyle;
        },
        buttonGray() {
            return this.formRoot.isButtonGray && ['submit', 'submit-container'].includes(this.props.actionType);
        },
    },
    async mounted() {
        this.timer = setTimeout(() => {
            if (this.clickTimer === 0) {
                this.clickTimer = 1;
            }
        }, 1500);
    },
    beforeDestroy() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    },
    methods: {
        updateButtonPosition() {
            window.onresize = () => {
                if (isIOS()) {return;}
                this.showHeight = document.documentElement.clientHeight || document.body.clientHeight;
                const diff = this.docmHeight - this.showHeight;
                if (this.docmHeight > this.showHeight && diff > 120) {
                    // 软键盘弹起-隐藏
                    console.log('[zy] updateButtonPosition 隐藏', );
                    this.noFixed = true;
                } else {
                    // 软键盘收起-显示
                    console.log('[zy] updateButtonPosition 显示', );
                    this.noFixed = false;
                }
            };

            const halfScreen = this.formRoot.initParams.halfScreen;

            const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const parentNode = this.$refs.btn.parentNode;
            if (inIm) {
                const panelTitle = document.querySelector('body > div.half-panel.collect-half-panel.full-screen-panel > div.panel > div.title');
                const panelTitleHeight = panelTitle ? panelTitle.clientHeight : 0;
                const imShouldFix = parentNode.clientHeight + panelTitleHeight + 56 < screenHeight;
                this.fixStyle = { bottom: '8px' };
                this.shouldFixed = imShouldFix && !halfScreen;
                // console.log('[zy] imShouldFix ', imShouldFix, parentNode.clientHeight + panelTitleHeight,
                //     screenHeight, panelTitleHeight, this.fixStyle);
            } else if (inCollect || process.env.NODE_ENV === 'development') {
                const footerEl = document.getElementsByClassName('biz-footer');
                const bottomDistance = footerEl && footerEl.length ? 86 : 8;
                const titleHeight = this.$refs.btn.parentNode.getBoundingClientRect().top;
                const shouldFix = parentNode.clientHeight < screenHeight - titleHeight - bottomDistance;
                const bottom = bottomDistance + 'px';
                this.fixStyle = { bottom };
                this.shouldFixed = shouldFix;
                // console.log('[zy] shouldFix', parentNode.clientHeight,
                //     screenHeight - titleHeight - bottomDistance, this.fixStyle);
            }
        },
        handleSubmit() {
            if (this.buttonGray) {
                // this.toastAndLog('请修改标红信息');
                // return;
            }
            this.formRoot && this.formRoot.onSubmitClick();
        },
        findParentContainer(vm) {
            const vmComp = getValueByPath(vm, 'config.component');
            if (vmComp && vmComp === FormContainerComp) {
                return vm;
            }
            if (vm.$parent) {
                return this.findParentContainer(vm.$parent);
            }
            // eslint-disable-next-line no-undefined
            return undefined;
        },
        // 举报中台增加了一种提交方式，只提交当前form-container的数据
        handleSubmitContainer() {
            const containerVm = this.findParentContainer(this.$parent);
            if (containerVm && containerVm.submitSelfData) {
                // 约定container提交局部数据的方法
                containerVm.submitSelfData();
            }
        },
        handleDownload() {
            // todo ksBridge方式
            // iOS中其实不存在下载操作，下载功能其实是支持不了的……
            if (this.props.link) {
                window.open(this.props.link);
            }
        },
        handleHref() {
            if (this.props.link) {
                window.location.href = this.props.link;
            }
        },
        handleCustomEvent() {
            this.formRoot
                && this.formRoot.$emit(this.props.customEventName || 'custom-event', this.config);
        },
        handleClick() {
            // 检查clickTimer是否为1，以确保按钮只在正确渲染后可点击
            if (this.clickTimer !== 1) {
                return Toast.info('请勿快速点击！');
            }

            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.$emit('click');
            switch (this.props.actionType) {
                case 'submit':
                    this.handleSubmit();
                    break;
                case 'submit-container':
                    this.handleSubmitContainer();
                    break;
                case 'download':
                    this.handleDownload();
                    break;
                case 'href':
                    this.handleHref();
                    break;
                case 'dialog':
                    this.showDialog(this.props.dialogUid);
                    break;
                case 'custom-event':
                    this.handleCustomEvent();
                    break;
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        // 无
    },
};
</script>
<style lang="less" scoped>
.mobile-general-form-button {
    // margin: 16px;
    margin: 16px auto;
    margin-top: 6px;
    width: 225px;
    padding-bottom: env(safe-area-inset-bottom);
}

.fix-bottom {
    display: inherit;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
}
.no-show {
    display: none !important;
}
</style>

